import React, { ReactNode, useState } from 'react';
import { CairoProvider } from './CairoProvider';
import { WixPatternsEssentials, experimentsFallbackApi } from '@wix/bex-core';
import { Trans } from '@wix/bex-utils/@wix/wix-i18n-config';
import { WixPatternsMinimalEssentials } from './CairoMinimalEssentials';

export interface CairoUnknownEnvProviderProps {
  value: WixPatternsMinimalEssentials;
  children?: ReactNode;
  localCache?: boolean;
}

export function CairoUnknownEnvProvider({
  value: valueProp,
  children,
  ...rest
}: CairoUnknownEnvProviderProps) {
  const [value] = useState((): WixPatternsEssentials => {
    const experiments = experimentsFallbackApi();

    return {
      useExperiments: () => ({
        ready: true,
        experiments,
      }),
      experiments,
      Trans,
      ...valueProp,
      user: {
        permissions: [],
        ...valueProp.user,
      },
    };
  });

  return (
    <CairoProvider {...rest} value={value}>
      {children}
    </CairoProvider>
  );
}
